/**
 * Opens a given url in a new tab.
 *
 * Intended to be used with the `primaryContent` of the Beyond `Footer` as
 * it does not provide a way to supply other link attributes(e.g target etc)
 */
export const openInNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
